import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export default function PercentageOfMarketVolumeHelp() {
    return (
        <IconTooltip>
            <div>
                This charts your order&apos;s participation in the market
                compared to your average participation. This is displayed by
                time bins set in the chart configuration <Icon name="cog" />.
            </div>
        </IconTooltip>
    );
}
